import { useState } from 'react';

import { Button, Form, Input, Modal, Select, Typography } from 'antd';

import { AuthModal, ErrorResponse } from 'utils/types';

import FloatLabel from 'components/Common/FloatLabel';

import './index.scss';

interface CancellationReasonModalProps {
  setAuthDetailState: any;
  setCancelDisabled: any;
  isCancellationModalVisible: boolean,
  setIsCancellationModalVisible: any,
  isCancellationModalVisibleHandler(): any,
  authNo: string,
  companyId: string,
  cancelAuth(authNo: string, companyId: string, finalReason: string): any,
}

const CancellationReasonModal = (props : CancellationReasonModalProps) => {

  const { Option } = Select;
  const { Title } = Typography;
  const [form] = Form.useForm();
  const [isReasonTextRequired, setIsReasonTextRequired] = useState(false);

  const onSubmit = () => {
    form.validateFields().then(values => {
      const finalReason = values.selectReason === 'Other' ? values.reasonText : values.selectReason;
      if (finalReason) {
        props.cancelAuth(props.authNo, props.companyId, finalReason).then(() => {
          Modal.success({
            content: 'Cancellation request has been submitted, it may take 5-10 minutes for the authorization status to reflect these changes.',
          });
          resetModal();
          props.setIsCancellationModalVisible(false);
          props.setCancelDisabled(true);
          props.setAuthDetailState((prev: AuthModal) => ({ ...prev, status: 'Cancelled' }));
        }).catch((err: ErrorResponse) => {
          Modal.error({
            title: 'Cancellation Failed',
          });
          resetModal();
          props.setIsCancellationModalVisible(false);
        });
      }
    })
  };

  const handleReasonSelection = (reason: string) => {
    const ele= document.getElementById("OtherReason");
    if(reason === 'Other')
    {
      ele?.style.setProperty('visibility', 'visible');
      setIsReasonTextRequired(true);
    }
    else
    {
      ele?.style.setProperty('visibility', 'hidden');
      setIsReasonTextRequired(false);
    }
  };

  const handleCancel = () => {
    props.isCancellationModalVisibleHandler();
    form.resetFields();
    resetModal();
  };

  const resetModal = () => {
    form.resetFields();
    const ele= document.getElementById("OtherReason");
    ele?.style.setProperty('visibility', 'hidden');
    setIsReasonTextRequired(false);
  };

  return (
    <>
       <Modal      
          visible={props.isCancellationModalVisible}   
           width={750}
           onCancel={handleCancel}
           maskClosable={false}
           footer={[
            <div className="float-left">Required Fields <span className="asterisk">*</span></div>,
             <Button
               key="cancel"
               onClick={handleCancel}
             >
               Cancel
             </Button>,
             <Button
               type="primary"
               key="submit"
               form="getcancelReason"
               onClick={onSubmit}
             >
               Submit
             </Button>,
           ]}
         >
 
        <Title level={4} className="text-center">Cancel Reason</Title>
 
          <Form
            form={form}
            name="getcancelReason"
            onFinish={onSubmit}
          >
            <FloatLabel
              label="Please select a reason for cancellation:"
              name="selectReason"
              form={form}
              required
            >
              <Select
              id='selectReason'
              style={{ width: '100%', marginBottom: '10px' }}
               onSelect={(value : any) => {
                handleReasonSelection(value);                
              }}          
              >
                <Option key={1} value={"Request is no longer needed"}>Request is no longer needed</Option>
                <Option key={2} value={"Duplicate request"}>Duplicate request</Option>
                <Option key={3} value={"Request entered in error"}>Request entered in error</Option>
                <Option key={4} value={"Other"}>Other</Option>
              </Select>
            </FloatLabel>
            
            <div id='OtherReason' style={{visibility : 'hidden'}} >
            <FloatLabel
              float = {true}
              label="Describe 'Other' Reason"
              name="reasonText"
              form={form}
              required={isReasonTextRequired}
            >
              <Input
                id="inputOtherReason"
                type="text"
                style={{ width: '100%', marginBottom: '10px' }}
                maxLength={100}
                minLength={1}
              />
            </FloatLabel>
            </div>
        </Form>
      </Modal> 
    </>
  );
};

export default CancellationReasonModal;